import { render, staticRenderFns } from "./vin-ota.vue?vue&type=template&id=f9f0c3bc"
import script from "./vin-ota.vue?vue&type=script&lang=js"
export * from "./vin-ota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports